/**
 * Shared plan-coordinate helpers.
 *
 * SVG's y axis grows downward, so every plan polyline flips y to keep plan
 * north up. This is the single source for that string form.
 */

/** A plan point: an [x, y] pair. Extra trailing components (e.g. z) are ignored. */
export type FlipYPoint = readonly [number, number, ...number[]];

/**
 * SVG `points` attribute string for a plan polyline, with the y axis flipped
 * so plan north stays up (SVG y grows downward). Any component beyond [x, y]
 * (e.g. z in a Vec3) is ignored.
 */
export function flipYPoints(points: readonly FlipYPoint[]): string {
  return points.map(([x, y]) => `${x},${-y}`).join(" ");
}
